/**
 *
 * Asynchronously loads the component for AdvisorAddAsset
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorAddAsset = lazyLoad(
  () => import('./index'),
  module => module.AdvisorAddAsset,
);
